// extracted by mini-css-extract-plugin
module.exports = {"MicrosoftProducts":"MicrosoftProducts_MicrosoftProducts__OgVwZ","MicrosoftProductRequest":"MicrosoftProducts_MicrosoftProductRequest__1HBfC"};